var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.exibirLabelCustas
        ? _c("app-divider", {
            staticClass: "negative-margin-top margin-bottom",
            attrs: { label: "Cálculo de Custas" }
          })
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "margin-medium-top", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Diárias: ", required: true }
                        }),
                        _c("el-input-number", {
                          staticClass: "input",
                          attrs: {
                            type: "number",
                            size: "large",
                            min: 1,
                            name: "diárias",
                            disabled: _vm.disableCadastrarCustas
                          },
                          model: {
                            value: _vm.custa.numeroDiarias,
                            callback: function($$v) {
                              _vm.$set(_vm.custa, "numeroDiarias", $$v)
                            },
                            expression: "custa.numeroDiarias"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.exibirDataVencimento
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _vm.exibirDataVencimento
                    ? _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    staticClass: "input-default",
                                    attrs: { label: "Data de vencimento:" }
                                  }),
                                  _c(
                                    "el-date-picker",
                                    _vm._b(
                                      {
                                        staticClass: "input full-width",
                                        class: { erro: errors.length },
                                        attrs: {
                                          name: "data",
                                          type: "date",
                                          placeholder: "Selecione",
                                          format: "dd/MM/yyyy"
                                        },
                                        model: {
                                          value: _vm.custa.dataVencimento,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.custa,
                                              "dataVencimento",
                                              $$v
                                            )
                                          },
                                          expression: "custa.dataVencimento"
                                        }
                                      },
                                      "el-date-picker",
                                      _vm.$attrs,
                                      false
                                    )
                                  ),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3055047148
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.exibirFatorLocalizacao
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Município:" }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width input",
                                  class: { erro: errors.length },
                                  on: { change: _vm.changeFatorLocalizacao },
                                  model: {
                                    value: _vm.idMunicipio,
                                    callback: function($$v) {
                                      _vm.idMunicipio = $$v
                                    },
                                    expression: "idMunicipio"
                                  }
                                },
                                _vm._l(_vm.municipios, function(municipio) {
                                  return _c("el-option", {
                                    key: municipio.id,
                                    attrs: {
                                      label: municipio.nome,
                                      value: municipio.id
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1075668064
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin-medium-top", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xl: 8, lg: 8 } }, [
            _c(
              "div",
              { staticClass: "body-component" },
              [
                _c("el-card", { staticClass: "sizeCard" }, [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("span", { staticClass: "subtitle" }, [
                        _vm._v("Diárias do Motorista")
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "pad" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col"),
                          _c("app-label", {
                            staticClass: "label-diaria",
                            attrs: { label: "Valor da diária:" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required|min_value:0.01" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-double-input", {
                                      staticClass: "input",
                                      attrs: {
                                        hasValidationError: errors[0]
                                          ? true
                                          : false,
                                        disable: _vm.disableCadastrarCustas
                                      },
                                      model: {
                                        value: _vm.custa.valorMotorista.valor,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.custa.valorMotorista,
                                            "valor",
                                            $$v
                                          )
                                        },
                                        expression: "custa.valorMotorista.valor"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("app-label", {
                            staticClass: "label-funcionarios",
                            attrs: { label: "Número de funcionários:" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("el-input-number", {
                                      staticClass: "input",
                                      attrs: {
                                        type: "number",
                                        "controls-position": "right",
                                        size: "small",
                                        min: 1,
                                        name: "nº de funcionários",
                                        disabled: _vm.disableCadastrarCustas
                                      },
                                      model: {
                                        value:
                                          _vm.custa.valorMotorista.quantidade,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.custa.valorMotorista,
                                            "quantidade",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "custa.valorMotorista.quantidade"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c("app-display", {
                        attrs: {
                          label: "Custo Diárias (por funcionário): ",
                          required: false,
                          content: _vm.totalMotoristaPorFuncionario
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Total Custo Pessoal: ",
                          required: false,
                          content: _vm.totalMotorista
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
          !_vm.credenciadoVistoria
            ? _c("el-col", { attrs: { xl: 8, lg: 8 } }, [
                _c(
                  "div",
                  { staticClass: "body-component" },
                  [
                    !_vm.credenciadoVistoria
                      ? _c("el-card", { staticClass: "sizeCard" }, [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("span", { staticClass: "subtitle" }, [
                                _vm._v("Diárias de Vistoria")
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "pad" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col"),
                                  _c("app-label", {
                                    staticClass: "label-diaria",
                                    attrs: { label: "Valor da diária:" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required|min_value:0.01" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-double-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  hasValidationError: errors[0]
                                                    ? true
                                                    : false,
                                                  disable:
                                                    _vm.disableCadastrarCustas
                                                },
                                                model: {
                                                  value:
                                                    _vm.custa.valorVistoria
                                                      .valor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.custa.valorVistoria,
                                                      "valor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "custa.valorVistoria.valor"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2498474723
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-label", {
                                    staticClass: "label-funcionarios",
                                    attrs: { label: "Número de funcionários:" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("el-input-number", {
                                                staticClass: "input",
                                                attrs: {
                                                  type: "number",
                                                  "controls-position": "right",
                                                  size: "small",
                                                  min: 1,
                                                  name: "nº de funcionários",
                                                  disabled:
                                                    _vm.disableCadastrarCustas
                                                },
                                                model: {
                                                  value:
                                                    _vm.custa.valorVistoria
                                                      .quantidade,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.custa.valorVistoria,
                                                      "quantidade",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "custa.valorVistoria.quantidade"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1927186959
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("app-display", {
                                staticClass: "label-custas",
                                attrs: {
                                  label: "Custo Diárias (por funcionário): ",
                                  required: false,
                                  content: _vm.totalVistoriaPorFuncionario
                                }
                              }),
                              _c("app-display", {
                                staticClass: "label-custas",
                                attrs: {
                                  label: "Total Custo Pessoal: ",
                                  required: false,
                                  content: _vm.totalVistoria
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e(),
          !_vm.credenciadoGeomensor &&
          _vm.processo.tipoCodigo !== "CERTIDAO_TITULO"
            ? _c("el-col", { attrs: { xl: 8, lg: 8 } }, [
                _c(
                  "div",
                  { staticClass: "body-component" },
                  [
                    !_vm.credenciadoGeomensor &&
                    _vm.processo.tipoCodigo !== "CERTIDAO_TITULO"
                      ? _c("el-card", { staticClass: "sizeCard" }, [
                          _c(
                            "div",
                            {
                              staticClass: "clearfix",
                              attrs: { slot: "header" },
                              slot: "header"
                            },
                            [
                              _c("span", { staticClass: "subtitle" }, [
                                _vm._v("Diárias de Demarcação e Fiscalização")
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "pad" },
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col"),
                                  _c("app-label", {
                                    staticClass: "label-diaria",
                                    attrs: { label: "Valor da diária:" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required|min_value:0.01" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-double-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  hasValidationError: errors[0]
                                                    ? true
                                                    : false,
                                                  disable:
                                                    _vm.disableCadastrarCustas
                                                },
                                                model: {
                                                  value:
                                                    _vm.custa.valorDemarcacao
                                                      .valor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.custa.valorDemarcacao,
                                                      "valor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "custa.valorDemarcacao.valor"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      171114142
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("app-label", {
                                    staticClass: "label-funcionarios",
                                    attrs: { label: "Número de funcionários:" }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("el-input-number", {
                                                staticClass: "input",
                                                attrs: {
                                                  type: "number",
                                                  "controls-position": "right",
                                                  size: "small",
                                                  min: 1,
                                                  name: "nº de funcionários",
                                                  disabled:
                                                    _vm.disableCadastrarCustas
                                                },
                                                model: {
                                                  value:
                                                    _vm.custa.valorDemarcacao
                                                      .quantidade,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.custa.valorDemarcacao,
                                                      "quantidade",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "custa.valorDemarcacao.quantidade"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      592078386
                                    )
                                  })
                                ],
                                1
                              ),
                              _c("app-display", {
                                staticClass: "label-custas",
                                attrs: {
                                  label: "Custo Diárias (por funcionário): ",
                                  required: false,
                                  content: _vm.totalDemarcacaoPorFuncionario
                                }
                              }),
                              _c("app-display", {
                                staticClass: "label-custas",
                                attrs: {
                                  label: "Total Custo Pessoal: ",
                                  required: false,
                                  content: _vm.totalDemarcacao
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _c("el-row", {
                      staticClass: "margin-medium-top",
                      attrs: { gutter: 20 }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin-medium-top", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xl: 8, lg: 8 } },
            [
              _vm.exibirElaboracaoPublicacao
                ? _c("app-display", {
                    attrs: {
                      label:
                        "Elaboração/Publicação do edital que torna pública à alienação: ",
                      content: _vm.valorFixoEditalAlienacaoPublicaFormatado
                    }
                  })
                : _vm._e(),
              _vm.exibirFatorLocalizacao
                ? _c("app-display", {
                    attrs: {
                      label: "Fator de localização: ",
                      content: _vm.custa.fatorLocalizacao
                    }
                  })
                : _vm._e(),
              _vm.exibirNumeroModulos
                ? _c(
                    "div",
                    [
                      _vm.exibirNumeroModulos
                        ? _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        staticClass: "label-diaria",
                                        attrs: { label: "Número de módulos:" }
                                      }),
                                      _c("el-input-number", {
                                        staticClass: "input",
                                        attrs: {
                                          type: "number",
                                          size: "small",
                                          min: 1,
                                          "controls-position": "right",
                                          name: "nº de módulos",
                                          disabled: _vm.disableCadastrarCustas
                                        },
                                        model: {
                                          value: _vm.custa.numeroModulos,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.custa,
                                              "numeroModulos",
                                              $$v
                                            )
                                          },
                                          expression: "custa.numeroModulos"
                                        }
                                      }),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1993658259
                            )
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c("app-display", {
                staticClass: "totalLabel",
                attrs: {
                  label: "TOTAL À PAGAR:",
                  content: _vm.valorTotalCustas
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eed6f98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eed6f98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppGeracaoCustas.vue
// module id = null
// module chunks = 